export default {
    handle (src) {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.src = src
            img.decode().then(() => {
                resolve(img)
            })
            img.onerror = reject
        })
    }
}
